'use strict'

import velocity from 'velocity-animate'
import sizzle from 'sizzle'

export default (offset) => {
  velocity(sizzle('body')[0], 'scroll', {
    duration: 750,
    offset: offset,
    easing: 'easeOutSine'
  })
}



// WEBPACK FOOTER //
// ./client/lib/scrollDown.es6